module.exports = __webpack_public_path__ + "static/media/pic10.abb79f62.jpg";